import React from "react";
import TopHeader from "../TopHeader";

const AppShell = ({ showHeader = true, children }) => (
  <div className="min-h-screen bg-background">
    {showHeader && <TopHeader />}
    <div className={showHeader ? "pt-16" : ""}>{children}</div>
  </div>
);

export default AppShell;
